import React from 'react';
import UserInfo from '../components/UserInfo';
import Form from '../components/Form';
import { CenteredContainer } from '../components/Typography';
import styled from 'styled-components';
import { Helmet } from 'react-helmet';
const NoticeText = styled.p`
  font-family: 'Noto Sans';
  font-style: italic;
  font-weight: 600;
  font-size: 18px;
  line-height: 175%;
  text-align: center;
  color: rgb(243 0 0);
  white-space: pre-wrap;
  width: 50%;
  @media (max-width: 767px) {
    width: 100%;
    padding: 0 20px;
    margin-top: 30px;
    margin-bottom: 0;
    font-size: 15px;
    line-height: normal;
  }
`;
const ContriBox = styled.div`
  width: 80%;
  margin: auto;
  display: flex;
  flex-direction: row;
  box-shadow: 0px 25px 20px -20px rgba(0, 0, 0, 0.45);
  @media (max-width: 1024px) {
    width: 100%;
    flex-direction: column;
    padding: 0 15px;
    box-sizing: border-box;
  }
`;
const ContributionFirstPage = () => {
  const TITLE = 'Enter Amount - BSG Contribution Site';
  return (
    <>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>
      <ContriBox>
        <UserInfo />
        <Form />
      </ContriBox>
      <CenteredContainer marginBottom="40px">
        <NoticeText>
          “FOREIGN NATIONAL MEMBERS ARE NOT ALLOWED TO USE THIS SITE FOR MAKING
          CONTRIBUTION. IF ANY FOREIGN NATIONAL MEMBERS MAKES CONTRIBUTION
          THROUGH THIS SITE, BSG WOULD NOT ACCEPT THEIR CONTRIBUTION.”
        </NoticeText>
      </CenteredContainer>
    </>
  );
};

export default ContributionFirstPage;
